function tuto(ctx) {

	ctx.allowInteraction = false;
  
	let firstNode = ctx.timeline.songs.all.find(song => {
		return song.n_children > 0 && song.cover_ids.length > 0;
	});

	const tour = ctx.$shepherd({
		useModalOverlay: true,
		defaultStepOptions: {
			scrollTo: {behavior: "smooth", block: "center", inline: "center"},
			modalOverlayOpeningPadding: 4,
			arrow: true,
			canClickTarget: true,
			cancelIcon: {
				enabled: ctx.skippableTuto
			}
		}
	});

	tour.on("complete", () =>  {
		ctx.onTutoEnd();
	});

	tour.on("cancel", () =>  {
		ctx.onTutoEnd();
	});
  
	const buttons = [
		{
			text: "Précédent",
			action: tour.back,
			classes: "button is-light"
		},
		{
			text: "Suivant",
			action: tour.next,
			classes: "button is-primary"
		}
	];
  
	const lists = ctx.$refs.lists.sortedData;

	tour.addStep({
		text: "Bienvenue dans Muzlink : un outil interactif permettant d’explorer les relations d’inspiration et collaboration entre artistes.",
		buttons: [{
			text: "Suivant",
			action: tour.next,
			classes: "button is-primary"
		}]
	});
  
	tour.addStep({
		text: `Le graphe suivant présente les différents rôles occupés par ${ctx.artist.name} au cours de sa carrière.`,
		buttons: buttons,
		attachTo: {
			element: ".artist-stat-2",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Sur cette ligne du temps sont représentées les productions de l'artiste ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#timeline-1",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Ici sont affichées les <b>productions originales et adaptations</b> conçues par l'artiste ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: ".nodes-1",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `À droite complètement sont affichées les <b>reprises</b> chantées par l'artiste ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: ".covers-own",
			on: "top"
		},
		showOn () {
			return document.getElementsByClassName("covers-own")[0].childNodes.length > 0;
		}
	});
  
	tour.addStep({
		text: `Sur cette ligne du temps sont représentées les <b>inspirations</b> de ${ctx.artist.name}, c'est-à-dire les chansons à l'origine d’adaptations ou de reprises produites par ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#timeline-0",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Sur cette ligne du temps sont représentées les <b>chansons influencées</b> par l'artiste ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#timeline-2",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Ici sont affichées les <b>adaptations</b> issues des productions de l'artiste ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: ".nodes-2",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `À droite complètement sont affichées les <b>reprises</b> issues des productions de l'artiste ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: ".covers-target",
			on: "top"
		},
		showOn () {
			return document.getElementsByClassName("covers-target")[0].childNodes.length > 0;
		}
	});
  
	tour.addStep({
		text: `Ici, il est possible de voir les artistes qui <b>ont le plus souvent inspiré</b> l'artiste ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#list-0",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `En première position, on retrouve <b>${lists[0].data[0].artist.name}</b>, avec ${lists[0].data[0].scores[0].total} implications.`,
		buttons: buttons,
		attachTo: {
			element: "#list-0 .item-0",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Ici, il est possible de voir les artistes qui <b>ont le plus souvent collaboré</b> avec ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#list-1",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `En première position, on retrouve <b>${lists[1].data[0].artist.name}</b>, avec ${lists[1].data[0].scores[1].total} implications.`,
		buttons: buttons,
		attachTo: {
			element: "#list-1 .item-0",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `Ici, il est possible de voir les artistes qui <b>ont le plus souvent été influencés</b> par ${ctx.artist.name}.`,
		buttons: buttons,
		attachTo: {
			element: "#list-2",
			on: "top"
		}
	});
  
	tour.addStep({
		text: `En première position, on retrouve <b>${lists[2].data[0].artist.name}</b>, avec ${lists[2].data[0].scores[2].total} implications.`,
		buttons: buttons,
		attachTo: {
			element: "#list-2 .item-0",
			on: "top"
		}
	});
  
	tour.addStep({
		text: "Vous pouvez filtrer & trier les artistes par rôle: auteur, compositeur ou interprète",
		buttons: buttons,
		attachTo: {
			element: "#list-2 .artist-list-header .icons",
			on: "top"
		}
	});
  
	tour.addStep({
		text: "Il est possible de rechercher une chanson précise grâce à la <b>barre de recherche</b>.",
		buttons: buttons,
		attachTo: {
			element: "#song-search",
			on: "bottom"
		}
	});
  
	tour.addStep({
		text: "Lorsqu'on <b>clique sur une chanson</b>, une fiche descriptive avec des informations supplémentaires apparaît.",
		buttons: buttons,
		attachTo: {
			element: `#node-${firstNode.id}`,
			on: "top"
		},
		beforeShowPromise: () => {
			ctx.selectedSong = firstNode;
		}
	});
  
	tour.addStep({
		text: `On remarque ici que la chanson <b>${firstNode.label}</b> a été adaptée ${firstNode.n_children} fois et reprise ${firstNode.cover_ids.length} fois.`,
		buttons: [
			{
				text: "Précédent",
				action: tour.back,
				classes: "button is-light"
			},
			{
				text: "Terminer",
				action: tour.next,
				classes: "button is-primary"
			}
		],
		attachTo: {
			element: ".timeline-tree-container",
			on: "top"
		}
	});

	tour.start();
}

export default tuto;
